"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const nucleus_1 = require("@lifesize/nucleus");
const remoting_1 = require("../constants/remoting");
const redux_1 = require("../utils/redux");
exports.initialState = {
    activeCall: null,
    incomingCall: null
};
exports.default = redux_1.createReducer(exports.initialState, {
    [remoting_1.actions.REMOTE_STATE_UPDATED]: (state, action) => {
        return Object.assign(Object.assign({}, state), action.payload.state);
    },
    [nucleus_1.nucleusConstants.LOGOUT_FINISHED]: () => exports.initialState,
    [remoting_1.actions.DATA_CHANNEL_CLOSED]: state => {
        return get_1.default(state, 'app.remoting.pairing.isDisplay')
            ? state
            : Object.assign(Object.assign({}, state), { display: Object.assign(Object.assign({}, state.display), { sipIncomingCall: null, sipActiveCall: null }), activeCall: null, incomingCall: null });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/reducers/controller.js
// module id = 604
// module chunks = 0